/**
 * Dev mode utilities
 * This module provides compile-time checks for dev mode
 * Dev mode is enabled via VITE_MOCK_BACKEND environment variable
 */

/**
 * Check if dev mode is enabled
 * This is a compile-time constant that will be tree-shaken in production
 */
export const isMockBackend = import.meta.env.VITE_MOCK_BACKEND === 'true'
